// Add amount to props
import PropTypes from 'prop-types'
import React from 'react'
import { rtlConvertInline, css } from 'lib/paypalphrodite'
import { connect } from 'transfer/utils/p2p-connect'
import ShippingAddressDropdown from './shippingAddressDropdown'
import content from 'pp-react-l10n'
import {
  amountIsZero,
  amountAboveMinimumDonation,
  amountBelowMaximumDonation,
} from '../../lib/amountUtils'
import { ActionTypes as types, DONATION_VALIDATION_TYPES } from '../constants'
import styles from './share-my-address.styles'
import * as SendActions from 'transfer/actions/send'

let i18n = content('transfer/inc/donateDropdown')

class ShareMyAddress extends React.Component {
  static propTypes = {
    shareAddress: PropTypes.bool,
    shippingRequired: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
    currencyDecimal: PropTypes.string,
    isAmountReadOnly: PropTypes.bool,
    dir: PropTypes.string,
    donationContext: PropTypes.object,
  }

  validateAmount = () => {
    if (amountIsZero(this.props.amount, this.props.currencyDecimal)) {
      this.props.dispatch({
        type: types.EXTERNAL.SHOW_AMOUNT_IS_ZERO_ERROR,
      })
      return false
    }

    if (
      !amountAboveMinimumDonation(
        this.props.isAmountReadOnly,
        this.props.amount,
        this.props.donationContext.minimum_amount,
        this.props.currencyCode
      )
    ) {
      this.props.dispatch({
        type: types.EXTERNAL.SHOW_AMOUNT_DONATION_ERROR,
        data: DONATION_VALIDATION_TYPES.AMOUNT_BELOW_MINIMUM,
      })
      return false
    }

    if (
      !amountBelowMaximumDonation(
        this.props.isAmountReadOnly,
        this.props.amount,
        this.props.donationContext.maximum_amount,
        this.props.currencyCode
      )
    ) {
      this.props.dispatch({
        type: types.EXTERNAL.SHOW_AMOUNT_DONATION_ERROR,
        data: DONATION_VALIDATION_TYPES.AMOUNT_ABOVE_MAXIMUM,
      })
      return false
    }
    return true
  }

  reFetchFundingOptions = () => {
    if (this.validateAmount()) {
      this.props.dispatch(SendActions.fetchFundingOptions())
    }
    return
  }

  render() {
    if (!this.props.shippingRequired) {
      return null
    }

    return (
      <div className={css(styles.addressWrapper)}>
        <div
          className={`donate-mailing-address ${css(
            rtlConvertInline(styles.addressContent)
          )}`}
        >
          <ShippingAddressDropdown
            hasNoAddressNeededOption={false}
            onAddressChanged={this.reFetchFundingOptions}
            validateAmount={this.validateAmount}
          />
        </div>
        <div
          className={`donate-mailing-address-helper-text ${css(
            rtlConvertInline(styles.addressContent)
          )}`}
        >
          <span>{i18n('label.helperText')}</span>
        </div>
      </div>
    )
  }
}

export default connect(({ external, amount, server }) => ({
  shippingRequired: external.shippingRequired,
  shareAddress: external.shareAddress,
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  currencyDecimal: amount.currencyDecimal,
  isAmountReadOnly: !!external.isAmountReadOnly,
  dir: server.directionality,
  donationContext: external.donationContext,
}))(ShareMyAddress)
